import { EMPLOYER_NETWORK_BENCHMARKING_AND_DISRUPTION_TITLE } from '@/features/employer/config/constants'

const DashboardsRouter = () => import('@/features/dashboards/views/DashboardsRouterView.vue')
const DashboardsIndex = () => import('@/features/dashboards/views/DashboardsIndexView.vue')
const RadiologyDashboard = () => import('@/features/dashboards/views/RadiologyDashboardView.vue')

// Children of ViewAuthenticated for dashboards and employer analytics
export const dashboardsRoutes = [
    {
        path: 'dashboards',
        component: DashboardsRouter,
        meta: { title: 'Dashboards' },
        children: [
            {
                name: 'dashboards',
                path: '',
                component: DashboardsIndex,
            },
            {
                path: 'radiology',
                component: RadiologyDashboard,
                meta: { title: 'Radiology Dashboard' },
            },
            {
                path: 'behavioral-next',
                name: 'behavioral-next',
                component: () => import('@/features/dashboards/views/BHDashboardNextView.vue'),
                meta: { title: 'Behavioral Health Dash' },
            },
            {
                path: 'behavioral-compare',
                name: 'behavioral-compare',
                component: () => import('@/features/dashboards/views/BHDashboardCompareView.vue'),
                meta: { title: 'Behavioral Health Comparison Dash' },
            },
            {
                path: 'referral-analytics',
                name: 'referral-analytics',
                component: () => import('@/features/dashboards/views/ReferralAnalyticsDashboardView.vue'),
                meta: { title: 'Referral Analytics' },
            },
        ],
    },
    {
        path: 'employer',
        component: DashboardsRouter,
        meta: { title: 'Employer Analytics' },
        children: [
            {
                path: 'employer-network-report',
                name: 'employer-network-report',
                component: () => import('@/features/employer/views/EmployerNetworkReportDashboardView.vue'),
                meta: { title: EMPLOYER_NETWORK_BENCHMARKING_AND_DISRUPTION_TITLE },
            },
            {
                path: 'claims-disruption',
                redirect: { name: 'employer-network-report' },
            },
            {
                path: 'census-generator',
                name: 'census-generator',
                component: () => import('@/features/employer/views/SyntheticCensusGeneratorView.vue'),
                meta: { title: 'Synthetic Census Generator' },
            },
            {
                path: 'payment-integrity',
                name: 'payment-integrity',
                component: () => import('@/features/employer/views/PaymentIntegrityDashboardView.vue'),
                meta: { title: 'Payment Integrity' },
            },
        ],
    },
]
